/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import2 from '../../ui-elements/spinner/spinner.component';
import * as import3 from '../../html-utils/css-var.directive';
import * as import4 from '@angular/common';
import * as import5 from './google-pay-button.component';
import * as import6 from '../../payment/payment.model';
import * as import7 from '../../orchestration/session.model';
const styles_GooglePayButtonComponent:any[] = ([] as any[]);
export const RenderType_GooglePayButtonComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_GooglePayButtonComponent,
  data: {}
}
);
function View_GooglePayButtonComponent_1(l:any):import0.ɵViewDefinition {
    return import0.ɵvid(0,[(l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'googlePayButtonContainer',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'class',
        'google-pay-button'
      ]
  ],(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_GooglePayButtonComponent_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'id',
        'tyro-google-pay-form-holder'
      ]
  ],(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_GooglePayButtonComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',[[
        'class',
        'face-spinner'
      ]
    ],(null as any),(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import2.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export function View_GooglePayButtonComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{googlePayButtonContainer: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'face'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      import0.ɵdid(671744,(null as any),0,import3.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--google-pay-button-type',
      '--google-pay-button-color'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GooglePayButtonComponent_1)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GooglePayButtonComponent_2)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GooglePayButtonComponent_3)),
    import0.ɵdid(16384,(null as any),0,import4.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.GooglePayButtonComponent = v.component;
    const currVal_0:any = ck(v,3,0,co.type,co.color);
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.isPassive;
    ck(v,6,0,currVal_1);
    const currVal_2:boolean = (!co.isPassive && (co.paymentModel.paymentProvider === co.IntegratedPaymentProvider.TYRO));
    ck(v,9,0,currVal_2);
    const currVal_3:any = (co.showSpinner || co.showTyroSpinner);
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_GooglePayButtonComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-google-pay-button',([] as any[]),[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_GooglePayButtonComponent_0,RenderType_GooglePayButtonComponent)),
    import0.ɵdid(4898816,(null as any),0,import5.GooglePayButtonComponent,[
      import0.ElementRef,
      import6.PaymentModel,
      import0.ChangeDetectorRef,
      import7.SessionModel
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).disabled;
    const currVal_1:any = import0.ɵnov(v,1).button;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const GooglePayButtonComponentNgFactory:import0.ComponentFactory<import5.GooglePayButtonComponent> = import0.ɵccf('woa-google-pay-button',import5.GooglePayButtonComponent,View_GooglePayButtonComponent_Host_0,{
  passive: 'passive',
  type: 'type',
  disabled: 'disabled',
  showSpinner: 'showSpinner'
}
,{
  pay: 'pay',
  paymentStarted: 'paymentStarted',
  paymentComplete: 'paymentComplete',
  paymentFailed: 'paymentFailed',
  paymentCancelled: 'paymentCancelled'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/buttons/google-pay-button/google-pay-button.component.ngfactory.ts